import * as React from 'react';
import { useState, useEffect } from 'react';

import Thumb from './ExampleThumb';
import Feature from './ExampleFeature';
import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import TourStep from '../tour/TourSteps';
import { FlyerData } from '../data/FlyerData';
import { getExamples } from '../utils/FirebaseUtils';
import { Overlay } from '../components/Overlay';

interface FilterOptionProps {
  value: string;
  onSelect: Function;
  selected: boolean;
}

const FilterOption: React.FunctionComponent<FilterOptionProps> = props => {
  return (
    <li
      onClick={() => props.onSelect(props.value)}
      className={props.selected ? 'selected' : ''}
    >
      {props.value}
    </li>
  );
};

interface FeaturesFilterProps {
  selectedFeature: string | null;
  onSelect: Function;
}

const FeaturesFilter: React.FunctionComponent<FeaturesFilterProps> = props => {
  return (
    <div className="feature-filter">
      Filter by feature:
      <ul
        className={
          'features' + (props.selectedFeature ? ' features--has-selection' : '')
        }
      >
        {[
          Feature.MultiFrames,
          Feature.Video,
          Feature.SplitLayer,
          Feature.AudioSpectrum
        ].map(feature => {
          return (
            <FilterOption
              key={feature}
              value={feature}
              onSelect={props.onSelect}
              selected={
                props.selectedFeature !== null &&
                props.selectedFeature === feature
              }
            />
          );
        })}
      </ul>
    </div>
  );
};

const Examples: React.FunctionComponent = () => {
  const [selectedFeature, setSelectedFeature] = useState<string | null>(null);
  const [items, setItems] = useState<FlyerData[] | null>(null);

  useEffect(() => {
    storeDispatch(Actions.skipTourStepIfEqualsTo(TourStep.ViewExamples));
    getExamples()
      .then(examples => {
        setItems(examples);
      })
      .catch(e => {
        console.error(e);
      });
  }, []);

  if (!items) {
    return null;
  }
  const children: JSX.Element[] = [];
  items.map(item => {
    if (
      !item.private &&
      (selectedFeature === null ||
        (item.features && item.features.indexOf(selectedFeature!) > -1))
    ) {
      children.push(
        <Thumb
          url={item.thumb!}
          preview={item.preview!}
          name={item.id!}
          key={item.id}
        />
      );
    }
    return item;
  });

  while (children.length % 4 > 0) {
    children.push(<div key={children.length} className="ghost-thumb" />);
  }

  return (
    <Overlay fullWidth={true}>
      <FeaturesFilter
        selectedFeature={selectedFeature}
        onSelect={(feature: string) =>
          setSelectedFeature(feature === selectedFeature ? null : feature)
        }
      />
      <div className="examples-container">
        {children.length > 0 ? (
          children
        ) : (
          <p>There are no examples yet demonstrating this feature.</p>
        )}
      </div>
    </Overlay>
  );
};

export default Examples;



// WEBPACK FOOTER //
// ./src/examples/index.tsx